dealershipModule.factory('dealerProfileService',
    ['DealerProfile', 'commonRESTCallService', 'AppSettings', 'imSessionVarsService', 'erateSessionVarsService', 'settingsCacheService', '$q', 'dealershipModuleConstants',
        function(DealerProfile, commonRESTCallService, AppSettings, imSessionVarsService, erateSessionVarsService, settingsCacheService, $q, dealershipModuleConstants) {
            var dealerProfileService = {};
            var _referenceDate = Date.today();
            var defaultDealerProfile = settingsCacheService.getCachedDealerProfile(dealershipModuleConstants.DEFAULT_PRODUCT, _referenceDate);

            dealerProfileService.getDealerProductProfile = function(productCode, _referenceDate) {
                var returnValPromise = $q.defer();
                var dealerProductProfile = settingsCacheService.getCachedDealerProfile(productCode, _referenceDate);
                if (dealerProductProfile) {
                    returnValPromise.resolve(dealerProductProfile);
                } else {
                    // The business services end point:
                    //"GetDealerProfileProductById/{applicationPartnerCode}/{dealerProviderCode}/{profileProductId}",
                    var getUrl = AppSettings.startSPANDealerProfileURL + '/GetDealerProfileProductByProductCode/' + imSessionVarsService.getCurrentProviderCode() + '/' +
                        erateSessionVarsService.getCurrentDealerAccountCode() + '/' + productCode;

                    commonRESTCallService.getFromServer(getUrl)
                        .success(function (responseData, status) {
                            //In case we have duplicates, always use the latest one
                            if (responseData.length > 0) {
                                var mostRecentOvrRemit = mostRecentOverRemit(responseData, _referenceDate);
                                var dealerProductProfileValue = new DealerProfile();
                                dealerProductProfileValue.populateDataFromBusinessSvcs(mostRecentOvrRemit[0]);
                                // Business Rules to disable Over Remit
                                var dealerProfileVisible = false;
                                var dealerProfileProduct = settingsCacheService.getCachedProfitSetting(dealerProductProfileValue.productData.Abbreviation.replace('/', '').toUpperCase(), _referenceDate);
                                if ((dealerProductProfileValue.productData.RateSource.toUpperCase() == 'LOCAL' || dealerProductProfileValue.productData.RateSource.toUpperCase() == 'REMOTE') &&  dealerProfileProduct.type.toUpperCase() != 'REGULATED'){
                                    dealerProfileVisible = true;
                                }

                                // End Business Rules
                                if (dealerProfileVisible) {
                                    settingsCacheService.setCachedDealerProfile(dealerProductProfileValue.productData.Abbreviation.toUpperCase(), _referenceDate, dealerProductProfileValue);
                                    returnValPromise.resolve(dealerProductProfileValue);
                                }
                                else {
                                    settingsCacheService.setCachedDealerProfile(dealerProductProfileValue.productData.Abbreviation.toUpperCase(), _referenceDate, defaultDealerProfile);
                                    returnValPromise.resolve(defaultDealerProfile);
                                }
                            }
                            else
                                returnValPromise.resolve(responseData);
                        })
                        .error(function (responseData, status) {
                            if (status === 404)
                                returnValPromise.reject("Dealer product profile not found");
                            else
                                returnValPromise.reject("Error retrieving Dealer product profile");
                        });
                }

                return returnValPromise.promise;
            };

            dealerProfileService.getAllDealerProductProfile = function() {
                var returnValPromise = $q.defer();

                settingsCacheService.clearCachedDealerProfile();

                // The business services end point:
                //"GetDealerProfileProducts/{applicationPartnerCode}/{dealerProviderCode}",
                var getUrl = AppSettings.startSPANDealerProfileURL + '/GetDealerProfileProducts/' + imSessionVarsService.getCurrentProviderCode() + '/' +
                    erateSessionVarsService.getCurrentDealerAccountCode();

                commonRESTCallService.getFromServer(getUrl)
                    .success(function(responseData, status) {
                        var dealerProductsProfile = responseData.map(function(busSvcProfile) {
                            var dealerProductProfile = new DealerProfile();
                            dealerProductProfile.populateDataFromBusinessSvcs(busSvcProfile);
                            return dealerProductProfile;
                        });
                        dealerProductsProfile.forEach(function(dealerProductProfile) {
                            if (dealerProductProfile.productData.RateSource.toUpperCase() == 'LOCAL' || dealerProductProfile.productData.RateSource.toUpperCase() == 'REMOTE') {
                                settingsCacheService.setCachedDealerProfile(dealerProductProfile.productData.Abbreviation.toUpperCase(), _referenceDate, dealerProductProfile);
                            }
                        });

                        returnValPromise.resolve(dealerProductsProfile);
                    })
                    .error(function(responseData, status) {
                        returnValPromise.reject("Error retrieving dealer products profile");
                    });

                return returnValPromise.promise;
            };

            dealerProfileService.updateDealerProductProfile = function(_referenceDate, dealerProfile) {
                var returnValPromise = $q.defer();

                // The business services endpoint:
                //"UpdateDealerProfileProduct/{applicationPartnerCode}/{dealerProviderCode}/{profileProductId}"
                var saveUrl = AppSettings.startSPANDealerProfileURL + '/UpdateDealerProfileProduct/'+ imSessionVarsService.getCurrentProviderCode() + '/' +
                    erateSessionVarsService.getCurrentDealerAccountCode() +  '/' + dealerProfile._id;

                var dealerProfileData = dealerProfile.convertForBusinessSvcs();

                commonRESTCallService.putToServer(saveUrl, dealerProfileData)
                    .success(function(responseData, status) {
                        settingsCacheService.setCachedDealerProfile(dealerProfile.productData.Abbreviation.toUpperCase(), _referenceDate, dealerProfile);
                        returnValPromise.resolve(true);
                    }).error(function(responseData, status) {
                        returnValPromise.reject();
                    });

                return returnValPromise.promise;
            };

            function mostRecentOverRemit(overRemits, date)  {
                if (!overRemits || overRemits.length == 0) {
                    return null;
                };
                if (overRemits.length > 1) {
                    var result = overRemits.reduce(function (prev, current) {
                        return (current._createdDate >= prev._createdDate && current._createdDate <= date) ? current : prev;
                    });
                }
                return overRemits;
            }

            return dealerProfileService;
        }]);